var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 33.2275H22.5C30 33.2275 33 30.2275 33 22.7275V13.7275C33 6.22754 30 3.22754 22.5 3.22754H13.5C6 3.22754 3 6.22754 3 13.7275V22.7275C3 30.2275 6 33.2275 13.5 33.2275Z",
    stroke: "#FFBE00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23.4775C18.6894 23.4775 19.3721 23.3417 20.0091 23.0779C20.646 22.8141 21.2248 22.4274 21.7123 21.9398C22.1998 21.4523 22.5865 20.8736 22.8504 20.2366C23.1142 19.5997 23.25 18.917 23.25 18.2275C23.25 17.5381 23.1142 16.8554 22.8504 16.2185C22.5865 15.5815 22.1998 15.0027 21.7123 14.5152C21.2248 14.0277 20.646 13.641 20.0091 13.3772C19.3721 13.1133 18.6894 12.9775 18 12.9775C16.6076 12.9775 15.2723 13.5307 14.2877 14.5152C13.3031 15.4998 12.75 16.8352 12.75 18.2275C12.75 19.6199 13.3031 20.9553 14.2877 21.9398C15.2723 22.9244 16.6076 23.4775 18 23.4775V23.4775Z",
    stroke: "#FFBE00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.454 10.7275H26.472",
    stroke: "#FFBE00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.f21b8c098b7b5477880575d552b758aa.svg";
export { ForwardRef as ReactComponent };